<template>
    <div class="default-group">
        <div class="card-curvey group-card">
            <!-- <v-icon class="copy-group-icon border-radius-standard" @click="copyGroupDialog = true">content_copy</v-icon> -->
               <v-dialog v-model="copyGroupDialog" width="400">
                   <v-card class="border-radius-standard">
                       <v-card-title>
                            Copy Group
                            <v-spacer />
                            <v-icon @click="copyGroupDialog = false">close</v-icon>
                       </v-card-title>
                       <v-card-text>
                           <label>Name</label>
                           <v-text-field
                             v-model="copyInput.name"
                             outline />
                       </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn color="error" flat @click="copyGroupDialog = false">
                                Cancel
                            </v-btn>
                            <v-btn color="primary" @click="copyGroup">
                                Copy
                            </v-btn>
                        </v-card-actions>
                   </v-card>
               </v-dialog>
                <v-expansion-panel expand :value="0">
                    <v-expansion-panel-content>
                        <template v-slot:header>
                            <v-text-field
                                    class="solo-input handle min-width"
                                    v-model="group.title"
                                    @change="updateGroup"
                                    @click.native.stop="editTitle"
                            ></v-text-field>
                            <span v-if = "blocksList" class="primary--text text-xs-right"><span>{{ blocksList.length }}</span> Block<span v-if = "blocksList.length > 1">s</span></span>
                        </template>
                        <draggable @change="draggedToGroup" class="layout row wrap" v-model="blocksList" group="people" @start="drag=true" @end="drag=false" handle=".blockHandeler">
                            <v-flex xs4
                                    v-for="(block,index) in blocksList"
                                    :key="index"
                                    class="blockHandeler"
                            >
                                <v-btn
                                        large round block
                                        :color="selectedBlock.id === block.id ? 'primary': '#F1F1F1'"
                                        class = "border-radius-standard"
                                        @click="setSelectedBlock(block)"
                                >
                                    {{block.name}}
                                </v-btn>
                            </v-flex>
                            <v-flex :xs4 = "blocksList && blocksList.length" :xs12 = "!blocksList || !blocksList.length">
                                <v-btn
                                        large round block
                                        @click="addNewBlock(group.id)"
                                        color="white"

                                        class="text-gray"
                                >
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </v-flex>
                        </draggable>
                    </v-expansion-panel-content>
                 </v-expansion-panel>
        </div>
    </div>
</template>

<script>
    import common from "../../../utils/common";
    import draggable from 'vuedraggable'
    export default {
        name: "default-group",
        components: {
            draggable
        },
        props: {
            group: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            blocks: {
                type: Array,
                default: ()=> {
                    return []
                }
            },
            index: {
                Array,
                default: ()=> {
                    return 0
                }
            }
        },
        data() {
            return{
                blocksList: [],
                copyGroupDialog: false,
                copyInput: {
                    name: ''
                }
            }
        },
        mounted() {
            this.blocksList = this.blocks
            this.$root.$on('copy-group', payload => {
                if(payload === this.index) {
                    this.copyGroupDialog = true
                }
            })
        },
        methods: {
            setSelectedBlock(block) {
                this.$store.dispatch('setSelectedBlock',block)
            },
            addNewBlock(group_id) {
                this.$store.dispatch('setSavingStatus', true)
                this.$store.dispatch('setLoader',true)
                this.$http.post('/blocks',{
                    bot_id: this.botId,
                    group_id: group_id,
                    iGroup: -1,
                    name: `Untitled Block ${this.blocks.length+1}`,
                    payload: []
                })
                    .then(response=>{
                        this.blocks.push(response.data)
                        this.$store.dispatch('setSelectedBlock',response.data)
                        this.$store.dispatch('setNewBlock',response.data)
                        this.$store.dispatch('setSavingStatus', false)
                        this.$store.dispatch('setLoader',false)
                    })
                    .catch(error=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            draggedToGroup(newItem) {
                if(newItem.added || newItem.moved) {
                    this.updateBlockPosition(newItem.added || newItem.moved)
                }
            },
            async updateBlockPosition(newItem) {
               await this.$store.dispatch('setSavingStatus', true)
                await this.$store.dispatch('setLoader',true)
                let payload = await this.getBlockPayLoad(newItem.element.id)
                this.$http.put(`/blocks/${newItem.element.id}`,  {
                    group_id: this.group.id,
                    name: newItem.element.name,
                    payload: payload.data.payload,
                    order: newItem.newIndex
                })
                    .then(response=>{
                        this.$store.dispatch('setSavingStatus', false)
                        this.$store.dispatch('setLoader',false)
                    })
                    .catch(error=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            async getBlockPayLoad(blockId) {
                let response = await this.$http_bot.get(`/blocks/${blockId}`)
                return response
            },
            copyBlock() {
                this.$store.dispatch('setSavingStatus', true)
                this.$store.dispatch('setLoader',true)
                this.$http.post('/blocks',  {
                    bot_id: this.botId,
                    group_id: this.copiedBlock.group_id,
                    iGroup: -1,
                    name: `${this.copiedBlock.name} Copy`,
                    payload: this.copiedBlock.payload
                })
                    .then(response=>{
                        this.blocks.push(response.data)
                        this.$store.dispatch('setSelectedBlock',response.data)
                        this.$store.dispatch('setNewBlock',response.data)
                        this.$store.dispatch('setSavingStatus', false)
                        this.$store.dispatch('setLoader',false)
                    })
                    .catch(error=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            editTitle() {

            },
            updateGroup() {
                this.$store.dispatch('setLoader',true)
                this.$store.dispatch('setSavingStatus', true)
                this.$http.put(`groups/${this.group.id}`,{
                    order: this.index+1,
                    title: this.group.title
                })
                    .then(response=>{
                        this.$store.dispatch('setLoader',false)
                        this.$store.dispatch('setSavingStatus', false)
                    })
                    .catch((error)=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            copyGroup() {
                this.$store.dispatch('setLoader', true)
                this.$http.post(`/groups/${this.botId}/duplicate`,
                    { group_id: this.group.id, name: this.copyInput.name })
                .then(()=>{
                    this.$store.dispatch('setLoader', false)
                    this.copyGroupDialog = false
                    this.$store.dispatch('setSnackbar', {
                        text: `Copied Successfully`,
                        color: 'success',
                        status: true
                    })
                    this.$emit('copy')
                }).catch((err)=>{
                    this.$store.dispatch('setLoader', false)
                    this.$store.dispatch('setSnackbar', {
                        text: `Something Went Wrong`,
                        color: 'error',
                        status: true
                      })
                })
            }
        },
        computed: {
            selectedBlock () {
                return this.$store.state.blocksBuild.selectedBlock
            },
            copiedBlock() {
                return this.$store.state.blocksBuild.copiedBlock
            },
            botId() {
                return this.$store.state.bot.botId
            },
            updatedBlockName() {
                return this.$store.state.blocksBuild.updatedBlockName.name
            }
        },
        watch: {
            group(newVal , oldVal) {
              this.updateGroup()
            },
            blocks () {
                this.blocksList = this.blocks
            },
            copiedBlock(state) {
                if (state.id && state.group_id === this.group.id) {
                    this.copyBlock()
                }
            },
            updatedBlockName(state) {
                const block = this.$store.state.blocksBuild.updatedBlockName
                if (state) {
                    let index = _.findIndex(this.blocks,o=>{
                        return o.id === block.id
                    })
                    if (index !== -1) {
                        this.blocks[index].name = block.name
                    }
                }
            },
        }
    }
</script>

<style scoped>
.copy-group-icon {
    position: absolute;
    font-size: 18px;
    margin-top: -10px;
    margin-left: -10px;
    background-color: #FFFFFF;
    z-index: 2;
    padding: 5px;
    cursor: pointer;
}
</style>
